import React from 'react'
import img from '../../../../public/static/image-background/logo-v-02.png'
import { formatDateTime, useTranslation, titleTemplate, getBase64 } from '../../../../constants/helpers'
import config from '../../../../constants/config'

const Mau12 = ({ dataSeason, dataSchedules, size, id, numberRound, sponsorData, isShowSponsor }) => {
    const { t } = useTranslation()
    const width = size
    const px = size / 100
    const color = {
        bg1: '#1a0533',
        bg2: '#6B1A6B',
        bg3: '#8B1244',
        accent: '#ff9f00',
        accentLight: '#ffcc44',
        text: '#ffffff',
        textMuted: 'rgba(255,255,255,0.6)',
        glass: 'rgba(255,255,255,0.08)',
        glassBorder: 'rgba(255,255,255,0.18)',
        glassHover: 'rgba(255,255,255,0.13)'
    }
    const classCustom = size < 1000 ? 'view' : 'export'

    return (
        <div
            id={id}
            style={{
                width: width,
                minHeight: width / 1.3,
                fontFamily: 'SFUHelveticaCondensedBold',
                background: `linear-gradient(135deg, ${color.bg1} 0%, ${color.bg2} 50%, ${color.bg3} 100%)`,
                position: 'relative',
                overflow: 'hidden',
                padding: `${px * 2.5}px`
            }}
        >
            {/* Glow orbs background */}
            <div style={{ position: 'absolute', top: `-${px * 10}px`, left: `-${px * 10}px`, width: `${px * 50}px`, height: `${px * 50}px`, borderRadius: '50%', background: 'rgba(255,159,0,0.15)', filter: 'blur(30px)', zIndex: 0 }} />
            <div style={{ position: 'absolute', bottom: `-${px * 10}px`, right: `-${px * 10}px`, width: `${px * 60}px`, height: `${px * 60}px`, borderRadius: '50%', background: 'rgba(139,18,68,0.3)', filter: 'blur(30px)', zIndex: 0 }} />
            <div style={{ position: 'absolute', top: '40%', right: '20%', width: `${px * 30}px`, height: `${px * 30}px`, borderRadius: '50%', background: 'rgba(255,100,150,0.1)', filter: 'blur(20px)', zIndex: 0 }} />

            <div style={{ position: 'relative', zIndex: 1 }}>

                {/* ===== HEADER ===== */}
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: `${px * 2.5}px`,
                    background: color.glass,
                    backdropFilter: 'blur(20px)',
                    border: `1px solid ${color.glassBorder}`,
                    borderRadius: `${px * 1.5}px`,
                    padding: `${px * 1.8}px ${px * 2.5}px`,
                    boxShadow: `0 8px 32px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.1)`
                }}>
                    <Image src={dataSeason?.logo} style={{ width: `${px * 10}px`, height: `${px * 10}px`, objectFit: 'contain', filter: `drop-shadow(0 0 8px rgba(255,159,0,0.6))` }} />
                    <div style={{ flex: 1, textAlign: 'center' }}>
                        <h1 style={{
                            color: color.text,
                            fontSize: `${px * 4.8}px`,
                            textTransform: 'uppercase',
                            margin: 0,
                            letterSpacing: `${px * 0.3}px`,
                            textShadow: `0 0 20px rgba(255,159,0,0.7), 0 0 40px rgba(255,159,0,0.3), 0 2px 4px rgba(0,0,0,0.5)`
                        }}>
                            {t(titleTemplate(dataSchedules[0]?.dataGo))}
                        </h1>
                        <h2 style={{ color: color.accentLight, fontSize: `${px * 2.2}px`, textTransform: 'uppercase', margin: `${px * 0.5}px 0 0`, opacity: 0.9 }}>
                            {dataSeason?.name}
                        </h2>
                        {t(numberRound) === numberRound && (
                            <div style={{
                                display: 'inline-block',
                                background: `linear-gradient(90deg, ${color.accent}, ${color.accentLight})`,
                                color: '#000', padding: `${px * 0.4}px ${px * 2.5}px`,
                                borderRadius: `${px * 3}px`,
                                fontSize: `${px * 2}px`, fontWeight: 'bold', marginTop: `${px * 0.6}px`
                            }}>
                                {t('round')} {numberRound}
                            </div>
                        )}
                        {t(numberRound) && t(numberRound) !== numberRound && (
                            <div style={{
                                display: 'inline-block',
                                background: `linear-gradient(90deg, ${color.accent}, ${color.accentLight})`,
                                color: '#000', padding: `${px * 0.4}px ${px * 2.5}px`,
                                borderRadius: `${px * 3}px`,
                                fontSize: `${px * 2}px`, fontWeight: 'bold', marginTop: `${px * 0.6}px`
                            }}>
                                {t(numberRound)}
                            </div>
                        )}
                    </div>
                    <Image src={img} style={{ width: `${px * 10}px`, height: `${px * 10}px`, objectFit: 'contain' }} />
                </div>

                {/* ===== MATCHES — 2 COLUMNS ===== */}
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: `${px * 1.5}px` }}>
                    {dataSchedules[0]?.dataGo
                        ?.filter(i => i.awayTeam.name !== 'hidden' && i.homeTeam.name !== 'hidden')
                        ?.map((i, idx) => (
                            <Item
                                key={`${idx}${new Date()}`}
                                data={i}
                                px={px}
                                classCustom={classCustom}
                                idx={idx}
                                color={color}
                                width={width}
                            />
                        ))}
                </div>

                {/* ===== SPONSORS ===== */}
                {isShowSponsor && sponsorData?.length > 0 && (
                    <div style={{
                        marginTop: `${px * 2.5}px`,
                        background: color.glass,
                        backdropFilter: 'blur(20px)',
                        border: `1px solid ${color.glassBorder}`,
                        borderRadius: `${px}px`,
                        padding: `${px * 1.5}px ${px * 2}px`,
                        display: 'flex', justifyContent: 'center', alignItems: 'center',
                        flexWrap: 'wrap', gap: `${px * 2}px`
                    }}>
                        {sponsorData?.slice(0, 10)?.map((i, idx) => (
                            <Image key={idx} src={i.logo || config.logo}
                                style={{ height: `${px * 5}px`, width: 'auto', objectFit: 'contain' }} />
                        ))}
                    </div>
                )}

                {/* FOOTER */}
                <p style={{ textAlign: 'right', color: 'rgba(255,255,255,0.4)', fontSize: `${px * 1.6}px`, marginTop: `${px * 1.2}px`, letterSpacing: '2px' }}>
                    {window.sessionStorage.getItem('HomeUrl') || 'VSPORTS.VN'}
                </p>
            </div>
        </div>
    )
}

// ===================== ITEM =====================
const Item = React.memo(
    ({ data, px, classCustom, idx, color, width }) => {
        const { t } = useTranslation()

        const arrRankName = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth', 'ninth', 'tenth']
        let teamHomeRankName = arrRankName.includes?.(data.homeTeam?.rankName) ? `${t(data.homeTeam?.rankName)}` : ''
        let teamAwayRankName = arrRankName.includes?.(data.awayTeam?.rankName) ? `${t(data.awayTeam?.rankName)}` : ''

        const arrName = ['Winquarterfinals_1', 'Winquarterfinals_2', 'Winquarterfinals_3', 'Winquarterfinals_4', 'Losesemifinal_1', 'Losesemifinal_2', 'Winsemifinal_1', 'Winsemifinal_2', 'UnknownName']

        let teamHomeName = arrName.includes(data.homeTeam?.name) || !data.homeTeam?.id ? `${t(data.homeTeam?.name) || data.homeTeam?.name}` : data.homeTeam?.name
        let teamAwayName = arrName.includes(data.awayTeam?.name) || !data.awayTeam?.id ? `${t(data.awayTeam?.name) || data.awayTeam?.name}` : data.awayTeam?.name

        let homeName = data?.homeTeam?.id ? teamHomeName : `${teamHomeRankName} ${teamHomeName}`
        let awayName = data.awayTeam?.id ? teamAwayName : `${teamAwayRankName} ${teamAwayName}`

        return (
            <div style={{
                width: `calc(50% - ${px * 0.75}px)`,
                background: color.glass,
                backdropFilter: 'blur(16px)',
                border: `1px solid ${color.glassBorder}`,
                borderRadius: `${px * 1.2}px`,
                padding: `${px * 1.5}px ${px * 1.8}px`,
                display: 'flex',
                alignItems: 'center',
                gap: `${px * 1.2}px`,
                position: 'relative',
                overflow: 'hidden',
                boxShadow: `0 4px 20px rgba(0,0,0,0.25), inset 0 1px 0 rgba(255,255,255,0.1)`,
                minHeight: `${px * 10.5}px`
            }}>
                {/* Subtle left glow accent */}
                <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: `${px * 0.4}px`, background: `linear-gradient(to bottom, ${color.accent}, ${color.accentLight}, ${color.accent})`, borderRadius: `${px}px 0 0 ${px}px` }} />

                {/* Home team */}
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: `${px * 0.6}px` }}>
                    <Image
                        src={data?.homeTeam?.logo}
                        style={{
                            width: `${px * 7}px`, height: `${px * 7}px`,
                            borderRadius: '50%', objectFit: 'cover',
                            border: `2px solid ${color.accent}`,
                            boxShadow: `0 0 12px rgba(255,159,0,0.4)`,
                            backgroundColor: '#fff'
                        }}
                    />
                    <Name
                        propClass={`home${data?.homeTeam?.id}${new Date().getTime()}${classCustom}${idx}`}
                        name={homeName} px={px} color={color.text}
                    />
                </div>

                {/* Center: time / score pill */}
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: `${px * 0.5}px`, flexShrink: 0, minWidth: `${px * 22}px` }}>
                    {data?.isCompleted ? (
                        <>
                            <div style={{
                                background: `linear-gradient(90deg, ${color.accent}, ${color.accentLight})`,
                                borderRadius: `${px * 3}px`,
                                padding: `${px * 0.5}px ${px * 2}px`,
                                color: '#000',
                                fontSize: `${px * 3.6}px`,
                                fontWeight: 900,
                                letterSpacing: '2px',
                                textAlign: 'center',
                                whiteSpace: 'nowrap',
                                boxShadow: `0 4px 15px rgba(255,159,0,0.5)`
                            }}>
                                {!data?.homeTeam?.isGiveUp && !data?.awayTeam?.isGiveUp && `${data?.homeTeam?.score} - ${data?.awayTeam?.score}`}
                                {data?.homeTeam?.isGiveUp && !data?.awayTeam?.isGiveUp && `0 - ${data?.awayTeam?.giveUpScore}`}
                                {!data?.homeTeam?.isGiveUp && data?.awayTeam?.isGiveUp && `${data?.homeTeam?.giveUpScore} - 0`}
                                {data?.homeTeam?.isGiveUp && data?.awayTeam?.isGiveUp && `-`}
                            </div>
                            {data?.hasPenalty && (
                                <span style={{ color: '#fc0366', fontSize: `${px * 1.4}px`, fontWeight: 'bold' }}>
                                    PK: {data?.homeTeam?.penaltyScore} - {data?.awayTeam?.penaltyScore}
                                </span>
                            )}
                            <span style={{ color: color.textMuted, fontSize: `${px * 1.3}px`, textAlign: 'center' }}>
                                {formatDateTime(data?.dateTime, 'dateTime')}
                            </span>
                        </>
                    ) : (
                        <>
                            <div style={{
                                background: `linear-gradient(90deg, ${color.accent}, ${color.accentLight})`,
                                borderRadius: `${px * 3}px`,
                                padding: `${px * 0.6}px ${px * 2.5}px`,
                                color: '#000',
                                fontSize: `${px * 2.8}px`,
                                fontWeight: 900,
                                textAlign: 'center',
                                whiteSpace: 'nowrap',
                                boxShadow: `0 4px 15px rgba(255,159,0,0.4)`
                            }}>
                                {formatDateTime(data?.dateTime, 'time')}
                            </div>
                            <span style={{ color: color.textMuted, fontSize: `${px * 1.3}px`, textAlign: 'center' }}>
                                {formatDateTime(data?.dateTime, 'date')}
                            </span>
                            {data?.stadium && (
                                <span style={{ color: color.textMuted, fontSize: `${px * 1.2}px`, textAlign: 'center', maxWidth: `${px * 14}px`, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                    📍 {data.stadium}
                                </span>
                            )}
                        </>
                    )}
                </div>

                {/* Away team */}
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: `${px * 0.6}px` }}>
                    <Image
                        src={data?.awayTeam?.logo}
                        style={{
                            width: `${px * 7}px`, height: `${px * 7}px`,
                            borderRadius: '50%', objectFit: 'cover',
                            border: `2px solid rgba(255,255,255,0.4)`,
                            boxShadow: `0 0 10px rgba(255,255,255,0.15)`,
                            backgroundColor: '#fff'
                        }}
                    />
                    <Name
                        propClass={`away${data?.awayTeam?.id}${new Date().getTime()}${classCustom}${idx}`}
                        name={awayName} px={px} color={color.text}
                    />
                </div>
            </div>
        )
    },
    (p, n) => JSON.stringify(p.data) === JSON.stringify(n.data)
)

// ===================== NAME =====================
const Name = React.memo(
    ({ name, px, propClass, color }) => {
        const reSizeBasedOnWidth = () => {
            const el = document.querySelector(`.${propClass}`)
            const container = document.querySelector(`.contain${propClass}`)
            if (!el || !container) return
            const fontSize = window?.getComputedStyle(el)?.fontSize
            el.style.fontSize = parseFloat(fontSize) - 0.2 * px + 'px'
            if (el.scrollHeight > container.clientHeight) reSizeBasedOnWidth()
        }
        const processInput = () => {
            const el = document.querySelector(`.${propClass}`)
            if (!el) return
            el.innerHTML = name
            el.style.fontSize = px * 2.2 + 'px'
            reSizeBasedOnWidth()
        }
        React.useEffect(() => { processInput() }, [name])

        return (
            <div className={`contain${propClass}`} style={{ width: '100%', height: `${px * 6}px`, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                <h2 className={propClass} style={{ color: color, textAlign: 'center', textTransform: 'uppercase', margin: 0, fontWeight: 'bold', lineHeight: 1.2, wordBreak: 'break-word', whiteSpace: 'normal', fontSize: `${px * 2.2}px` }} />
            </div>
        )
    },
    (p, n) => JSON.stringify(p.name) === JSON.stringify(n.name)
)

// ===================== IMAGE =====================
const Image = props => {
    const [data, setData] = React.useState(null)
    React.useEffect(() => {
        if (props.src) getBase64(props.src).then(r => setData(r))
    }, [props.src])
    return <img {...props} src={data} alt="" />
}

function areEqual(p, n) {
    return JSON.stringify(p.dataSchedules) === JSON.stringify(n.dataSchedules) &&
        JSON.stringify(p.isShowSponsor) === JSON.stringify(n.isShowSponsor) &&
        JSON.stringify(p.sponsorData) === JSON.stringify(n.sponsorData)
}

export default React.memo(Mau12, areEqual)
